<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
        <config-title-hang>
          <span slot="config_title_hang_ele2">全部可选对象</span>
        </config-title-hang>

        <!-- 服务器返回的所有区域列表 -->
        <config-hang
          v-for="(value , index) in Time022Data"
          :key="index"
          @click.native="selectObjectBtnHandle(value)"
          :selectState="computerSelectState(value.id) "
        >
          <span slot="config_hang_ele2">{{value.name}}</span>
          <img slot="config_hang_weixuan" src="~assets/img/config/weixuan.png" alt />
          <img slot="config_hang_xuanzhong" src="~assets/img/config/xuanzhong.png" alt />
        </config-hang>

        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
// import { mediumslateblue } from "color-name";
import { configPageDataRequest } from "views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js";

export default {
  data() {
    return {
      Time022Data: [
        {
          name: "周一",
          id: "1"
        },
        {
          name: "周二",
          id: "2"
        },
        {
          name: "周三",
          id: "3"
        },
        {
          name: "周四",
          id: "4"
        },
        {
          name: "周五",
          id: "5"
        },
        {
          name: "周六",
          id: "6"
        },
        {
          name: "周日",
          id: "7"
        }
      ],
      selectObjectID: "", ///当前选中的对象ID
      // businessIdDesc:"",//////当前选中的对象回显name
      ServeOneObjectinfo: {
        ////地址指向仓库  当前要进行设置对象的信息
      },
      serveOneCycTask027Data: {
        /////一个周期定时任务的数据
      }
    };
  },
  computed: {},
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    selectObjectBtnHandle(value) {
      ////这一块的逻辑BUG比较多，不宜改动
      console.log("111111");
      if (this.selectObjectID.indexOf(value.id) === -1) {
        if (this.selectObjectID.length === 0) {
          this.selectObjectID = this.selectObjectID + value.id;
        } else {
          this.selectObjectID = this.selectObjectID + "," + value.id;
        }
        console.log(this.selectObjectID);
      } else {
        // this.selectObjectID = this.selectObjectID.replace( ',' + value.id , '')
        if (this.selectObjectID.indexOf(value.id) === 0) {
          ////删除第一个位置字符的时候
          if (this.selectObjectID.length === 1) {
            ///删除第一个位置字符，并且只剩一个字符的时候
            // this.selectObjectID = this.selectObjectID.replace(value.id, "");
            this.$toast("请至少选择一个！");
          } else {
            ////删除其他位置字符的时候
            this.selectObjectID = this.selectObjectID.replace(
              value.id + ",",
              ""
            );
          }
        } else {
          this.selectObjectID = this.selectObjectID.replace("," + value.id, "");
        }

        console.log(this.selectObjectID);
      }

      // this.businessIdDesc = value.regionName + '(' + value.remark + ')'
    },
    saveReturnBtnHandle() {
      ///保存并返回按钮点击了
      if (this.$route.query.type === "022") {
        this.ServeOneObjectinfo.businessId3 = this.selectObjectID;
      }else if (this.$route.query.type === "027"){
        this.serveOneCycTask027Data.weeks = this.selectObjectID;

      }
        this.$router.go(-1);

    },
    computerSelectState(id) {
      ///选中状态的状态返回
      if (this.selectObjectID.indexOf(id) === -1) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    console.log("created阶段");
    if (this.$route.query.type === "022") {
      this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo; ////一个对象的地址信息拿过来
      this.selectObjectID = this.ServeOneObjectinfo.businessId3;
    } else if (this.$route.query.type === "027") {
      this.serveOneCycTask027Data = this.$store.state.configinfo.serveOneCycTask027Data; ////一个对象的地址信息拿过来
      this.selectObjectID = this.serveOneCycTask027Data.weeks;
    }
  }
};
</script>

<style>
</style>